import { ButtonProps } from "react-bootstrap";
import styled from "styled-components";

export interface ButtonStyledProps extends ButtonProps {
  color?: string;
  backgroundColor?: string;
  fullWidth?: boolean;
  auto?: boolean;
  noPaddingX?: boolean;
  noPadding?: boolean;
  fontWeight?: string;
  borderBottom?: string;
  borderTop?: string;
  borderRight?: string;
  borderLeft?: string;
  borderColor?: string;
  borderRadius?: string;
  paddingBottom?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
}

export const ButtonStyled = styled.button<ButtonStyledProps>`
  border-radius: ${({ borderRadius }) =>
    borderRadius ? borderRadius : "20px"};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "transparent"};
  color: ${({ color }) => (color ? color : "inherit")};
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "600")};
  text-align: center;
  padding-top: ${({ noPadding }) => (noPadding ? "0" : "7px")};
  padding-bottom: ${({ paddingBottom, noPadding }) =>
    noPadding ? "0px" : paddingBottom ? paddingBottom : "7px"};
  ${({ auto, noPaddingX, noPadding }) =>
    noPadding
      ? "padding-left: 0px; padding-right: 0px;"
      : noPaddingX
      ? "padding-left: 7px; padding-right: 7px;"
      : !auto
      ? "padding-left: 35px; padding-right: 35px;"
      : "padding-left: 15px; padding-right: 15px;"}
  border-top: ${({ borderTop }) => (borderTop ? borderTop : "none")};
  border-bottom: ${({ borderBottom }) =>
    borderBottom ? borderBottom : "none"};
  border-left: ${({ borderLeft }) => (borderLeft ? borderLeft : "none")};
  border-right: ${({ borderRight }) => (borderRight ? borderRight : "none")};
  border-color: ${({ borderColor }) => (borderColor ? borderColor : "none")};
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "none"};
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : "none")};
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "none")};
`;
